import React from 'react';
import KwickComfortLogoSrc from '../../../../assets/img/kwik-comfort-simp-logo.png';

const KwickComfortLogoTransparent = ({ className }) => (
  <img src={KwickComfortLogoSrc} alt="Kwick Comfort Logo" className={className} />
);

export default KwickComfortLogoTransparent;
